import React from 'react';
import { ReactComponent as WarningModal } from '../../../../../../assets/warningModal.svg';
import { ModalProps } from '../../../../../../components/Modal';
import ContainerModal from '../../../../../../components/ContainerModal';
import styled from 'styled-components';
import { Button } from '../../../../../../components';
import { WhatsappWhiteSM } from '../../../../../../components/Icons';
import { useAnalytics } from '../../../../../../hooks/useAnalytics';
import { useScheduleContext } from '../../../../../../contexts/ScheduleContext';
import { useServiceContext } from '../../../../../../contexts/ServiceContext';
import { useSpecialistContext } from '../../../../../../contexts/SpecialistContext';
import { useModuleContext } from '../../../../../../contexts/ModuleContext';
import { FirebaseEvents } from '../../../../../../utils/enums/firebase-events';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 14px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }

  & .tel {
    font-weight: 600;
    font-size: 16px;
    color: var(--blue-einstein);
    line-height: 24px;
  }
`;

const ButtonClose = styled(Button)``;

export type IModalProps = Pick<ModalProps, 'visible' | 'onClose'>;

export const CallCenterModal = ({ onClose, visible }: IModalProps) => {
  const { logEvent } = useAnalytics();
  const { selectedItem, scheduleSpecialistSelected } = useScheduleContext();
  const { selectedService } = useServiceContext();
  const { selectedSpecialist } = useSpecialistContext();
  const { selectedItemToSchedule } = useModuleContext();

  function emitCallCenterEvent() {
    logEvent({
      eventName: FirebaseEvents.schedule_redirect_call_center,
      eventParams: {
        service_id: selectedService.id,
        service_name: selectedService.name,
        product_name: selectedItem?.productName,
        product_id: selectedItem?.productId,
        unit_id: selectedItem?.unit?.catalogUnitId,
        unit_name: selectedItem?.unit?.name,
        attendanceType: selectedItem?.careType,
        phone: '551121510021'
      }
    });
  }

  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      childrenFooter={
        <Button
          iconLeft={<WhatsappWhiteSM />}
          title="Enviar mensagem"
          onClick={() => {
            logEvent({
              eventName: FirebaseEvents.schedule_redirect_support_whatsapp,
              eventParams: {
                service_id: selectedService.id,
                service_name: selectedService.name,

                ...(selectedItemToSchedule === 'SPECIALIST'
                  ? {
                      product_name: selectedSpecialist?.name,
                      product_id: selectedSpecialist?.id,
                      unit_id: scheduleSpecialistSelected?.unit?.catalogId,
                      unit_name: scheduleSpecialistSelected?.unit?.name,
                      attendanceType: scheduleSpecialistSelected?.attendanceType
                    }
                  : {}),
                ...(selectedItemToSchedule !== 'SPECIALIST'
                  ? {
                      product_name: selectedItem?.productName,
                      product_id: selectedItem?.productId,
                      unit_id: selectedItem?.unit?.catalogUnitId,
                      unit_name: selectedItem?.unit?.name,
                      attendanceType: selectedItem?.careType
                    }
                  : {}),
                phone: '551136202550'
              }
            });

            window.open(
              'https://api.whatsapp.com/send?phone=551136202550&text=programa_engravida_app%20%7c%2aEnvie%20esta%20mensagem%20para%20iniciar!%2a'
            );
          }}
        />
      }
    >
      <Container>
        <WarningModal />
        <h3 className="title">Informação importante</h3>
        <p className="subtitle">
          Para seguir com o agendamento, entre em contato com a nossa Central de Atendimento ligando no número{' '}
          <a className="tel" href="tel:+551121510021" onClick={emitCallCenterEvent}>
            (11) 2151-0021
          </a>{' '}
          ou pelo WhatsApp clicando no botão abaixo.
        </p>
        <p className="subtitle">Atendimento disponível de segunda a sexta, das 7h às 19h.</p>
      </Container>
    </ContainerModal>
  );
};
